import "core-js/index"

import "./getEventPath"
import "./Element.append"
import "./customFunctions"
